module.exports = __webpack_public_path__ + "static/media/report-transparent.35934d04.svg";